<template>
  <div>
    <div v-if="!total" class="well"> Nenhum resultado. </div>
    <div v-if="modoResultado === 'T' && total" id="resultadoTabela" class="row">
      <slot name="tabela" />
    </div>
    <div v-if="modoResultado === 'C' && total" id="resultadoFichas" class="row">
      <slot name="fichas" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlocoResultadoPesquisa',
  props: {
    total: {
      type: Number,
      default: 0,
    },
    modoResultado: {
      type: String,
      default: 'C',
    },
  },
}
</script>
